module.exports = __webpack_public_path__ + "img/alba-set-complet.d8f99871.jpg";